import styled from 'styled-components';

interface IKebabMenu {
  className?: string;
}

export const KebabMenu = ({ className }: IKebabMenu) => {
  return (
    <KebabMenu.Wrapper className={className} aria-label="menu" type="button">
      <KebabMenu.Dot />
      <KebabMenu.Dot />
      <KebabMenu.Dot />
    </KebabMenu.Wrapper>
  );
};

KebabMenu.Wrapper = styled.button`
  padding: 0 12px;
`;

KebabMenu.Dot = styled.div`
  height: 3px;
  width: 3px;
  background-color: ${({ theme }) => theme.colors.white};
  margin-bottom: 4px;
  :last-child {
    margin-bottom: 0;
  }
`;
